import React, { useCallback, useEffect } from 'react';

import Select from 'react-select';
import { stateObservable$ } from 'ui/util/rxjs/observables';

const STATE_OPTIONS = [
   { value: 'al', label: 'Alabama' },
   { value: 'ak', label: 'Alaska' },
   { value: 'az', label: 'Arizona' },
   { value: 'ar', label: 'Arkansas' },
   { value: 'ca', label: 'California' },
   { value: 'co', label: 'Colorado' },
   { value: 'ct', label: 'Connecticut' },
   { value: 'de', label: 'Delaware' },
   { value: 'dc', label: 'District of Columbia' },
   { value: 'fl', label: 'Florida' },
   { value: 'gu', label: 'Guam' },
   { value: 'ga', label: 'Georgia' },
   { value: 'hi', label: 'Hawaii' },
   { value: 'id', label: 'Idaho' },
   { value: 'il', label: 'Illinois' },
   { value: 'in', label: 'Indiana' },
   { value: 'ia', label: 'Iowa' },
   { value: 'ks', label: 'Kansas' },
   { value: 'ky', label: 'Kentucky' },
   { value: 'la', label: 'Louisiana' },
   { value: 'me', label: 'Maine' },
   { value: 'md', label: 'Maryland' },
   { value: 'ma', label: 'Massachusetts' },
   { value: 'mi', label: 'Michigan' },
   { value: 'mn', label: 'Minnesota' },
   { value: 'ms', label: 'Mississippi' },
   { value: 'mo', label: 'Missouri' },
   { value: 'mt', label: 'Montana' },
   { value: 'ne', label: 'Nebraska' },
   { value: 'nv', label: 'Nevada' },
   { value: 'nh', label: 'New Hampshire' },
   { value: 'nj', label: 'New Jersey' },
   { value: 'nm', label: 'New Mexico' },
   { value: 'ny', label: 'New York' },
   { value: 'nc', label: 'North Carolina' },
   { value: 'nd', label: 'North Dakota' },
   { value: 'oh', label: 'Ohio' },
   { value: 'ok', label: 'Oklahoma' },
   { value: 'or', label: 'Oregon' },
   { value: 'pa', label: 'Pennsylvania' },
   { value: 'pr', label: 'Puerto Rico' },
   { value: 'ri', label: 'Rhode Island' },
   { value: 'sc', label: 'South Carolina' },
   { value: 'sd', label: 'South Dakota' },
   { value: 'tn', label: 'Tennessee' },
   { value: 'tx', label: 'Texas' },
   { value: 'ut', label: 'Utah' },
   { value: 'vt', label: 'Vermont' },
   { value: 'va', label: 'Virginia' },
   { value: 'vi', label: 'Virgin Islands' },
   { value: 'wa', label: 'Washington' },
   { value: 'wv', label: 'West Virginia' },
   { value: 'wi', label: 'Wisconsin' },
   { value: 'wy', label: 'Wyoming' },
];

const ReduxStateSelect = (props) => {
   const { meta: { touched, error } } = props;

   useEffect(() => {
      const subscription = stateObservable$.subscribe((state) => {
         if (props.input && props.input.onChange) {
            props.input.onChange(state);
         }
      });

      return () => {
         subscription.unsubscribe();
      };
   }, []);

   const handleChange = useCallback((option) => {
      if (props.input && props.input.onChange) {
         props.input.onChange(option.value);
      }
   });

   const getSelectedValue = useCallback(() => {
      const { value } = props.input;
      if (value) {
         return STATE_OPTIONS.find((option) => option.value.toLowerCase() === value.toLowerCase());
      } else {
         return null;
      }
   }, [props.input.value]);

   return (
      <Select
         style={{ minWidth: '500px' }}
         className={`react-select-container ${ props.className ? props.className : '' } ${ touched && error ? ' is-invalid ' : '' }`}
         classNamePrefix='react-select'
         isSearchable={false}
         value={getSelectedValue()}
         onChange={handleChange}
         options={STATE_OPTIONS}
         maxMenuHeight={135}
         required={props.required}
         isDisabled={props.isDisabled}
         blurInputOnSelect={false}
         placeholder={props.placeholder}
      />
   );
};

export default ReduxStateSelect;
